<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.875 6.375C7.875 4.09683 9.72183 2.25 12 2.25C14.2782 2.25 16.125 4.09683 16.125 6.375C16.125 8.65317 14.2782 10.5 12 10.5C9.72183 10.5 7.875 8.65317 7.875 6.375Z"
				:fill="color"
			/>
			<path
				d="M4.875 19.125C4.875 15.19 8.06497 12 12 12C15.935 12 19.125 15.19 19.125 19.125V19.1276C19.125 19.1674 19.1246 19.2074 19.124 19.2469C19.1196 19.5054 18.9824 19.7435 18.7609 19.8768C16.7857 21.0661 14.4716 21.75 12 21.75C9.52843 21.75 7.2143 21.0661 5.23906 19.8768C5.01756 19.7435 4.88037 19.5054 4.87603 19.2469C4.87534 19.2064 4.875 19.1657 4.875 19.125Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMySession',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
